import React, { ReactNode } from "react";
import SubscriptionCard from "./components/SubscriptionCard";
import Hero from "../../components/Hero";
import MainButton from "../../components/buttons/MainButton";
import { t } from "i18next";
import { useParams, useSearchParams } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

const PaymentSuccess = () => {
  const { currentLanguageCode } = useLanguage();
  const { approvalStatus } = useParams();
  const [searchParams] = useSearchParams(); 
  const status = searchParams.get("status");
  const plan = searchParams.get("plan");

  return (
    <>
      <section className="success-message-page">
        <div className={"container"}>
          <div className={"mb-5 mt-5"}>
            {/* <Hero text={`Payment ${status}`} /> */}
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8 text-center">
                <h1 className="success-head mb-5">
                  {status === "success"
                    ? `${t("success.success")} (${
                        plan === "BASIC" &&
                        ["en", "de", "id"].includes(currentLanguageCode)
                          ? t("basic.heading")
                          : plan === "MID" &&
                            ["en", "de", "id"].includes(currentLanguageCode)
                          ? t("mid.heading")
                          : plan === "PREMIUM" &&
                            ["en", "de", "id"].includes(currentLanguageCode)
                          ? t("premium.heading")
                          : ""
                      })`
                    : // ${currentLanguageCode == "en" ? }
                      "unfortunately your payment was cancelled please choose your plan again"}
                </h1>

                <MainButton
                  href={"/"}
                  text={"Back to Home"}
                  className={`btn btn-primary-dark ps-lg-5 pe-lg-5 ps-3 pe-3 `}
                  withLogo={true}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PaymentSuccess;



// import { useNavigate } from 'react-router-dom';

// // ... inside your component
// const navigate = useNavigate();
// const { currentLanguageCode } = useLanguage(); // Assuming this gives you the current language

// const handlePaymentResult = (paymentStatus, paymentPlan) => {
//     // Example of navigating after a payment result
//     navigate(`/<span class="math-inline">\{currentLanguageCode\}/subscription?status\=</span>{paymentStatus}&plan=${paymentPlan}`);
// };

// const handleLanguageChange = (newLang) => {
//     // When changing language, preserve existing query parameters
//     const currentStatus = searchParams.get("status");
//     const currentPlan = searchParams.get("plan");

//     let queryString = '';
//     if (currentStatus) {
//         queryString += `status=${currentStatus}`;
//     }
//     if (currentPlan) {
//         queryString += `<span class="math-inline">\{queryString ? '&' \: ''\}plan\=</span>{currentPlan}`;
//     }

//     navigate(`/<span class="math-inline">\{newLang\}/subscription</span>{queryString ? `?${queryString}` : ''}`);
// };